const A = "https://customer-assets-jai6qajn.emergentagent.net/job_natural-rnb/artifacts";

export const IMAGES = {
  hero: `${A}/dd32dc4e3e8be537_DSC02711-%28ZF-1885-69073-1-001%29.JPG`,
  about: `${A}/1a1be9845f921816_IMG_0934.webp`,
  vipBanner: `${A}/5dffe5c285c8ddc4_IMG_0159.webp`,
  mockup: `${A}/39da01da829445ba_IMG_9212.webp`,
  darkBackdrop: `${A}/4c7105ecd10b8142_IMG_8551.webp`,
  daniTransformation: `${A}/f95532232144b60b_7.jpg`,
  transformations: [
    { src: `${A}/f95532232144b60b_7.jpg`, label: "Dani Postigo", tag: "EL PROPIO MÉTODO" },
    { src: `${A}/e2fefc7d9776afbc_6.jpg`, label: "Cliente Team RNB", tag: "ANTES / DESPUÉS" },
    { src: `${A}/a5ce08bb166c804a_8.jpg`, label: "Cliente Team RNB", tag: "2 MESES TRABAJANDO JUNTOS" },
    { src: `${A}/f6ec46347f9cda9c_1.jpg`, label: "Cliente Team RNB", tag: "RECOMPOSICIÓN" },
    { src: `${A}/2269a2845a66ad43_2.jpg`, label: "Cliente Team RNB", tag: "PÉRDIDA DE GRASA" },
    { src: `${A}/d4c1abc0cb7748e8_3.jpg`, label: "Cliente Team RNB", tag: "DEFINICIÓN" },
    { src: `${A}/3372dc707d4fd156_5.jpg`, label: "Cliente Team RNB", tag: "ANTES / DESPUÉS" },
  ],
  gallery: [
    { src: `${A}/493c2500f044fe7f_IMG_8821%202.webp`, pos: "object-top" },
    { src: `${A}/a60375d467f112b6_IMG_8820%202.jpg`, pos: "object-top" },
    { src: `${A}/39da01da829445ba_IMG_9212.webp`, pos: "object-[center_65%]" },
    { src: `${A}/2aaff26e04bc43cd_IMG_9219.webp`, pos: "object-[center_70%]" },
  ],
  editorial: {
    victory: `${A}/493c2500f044fe7f_IMG_8821%202.webp`,
    medal: `${A}/a60375d467f112b6_IMG_8820%202.jpg`,
    ocbPose: `${A}/39da01da829445ba_IMG_9212.webp`,
    team: `${A}/2aaff26e04bc43cd_IMG_9219.webp`,
    bgTraining: `${A}/5dffe5c285c8ddc4_IMG_0159.webp`,
    bgStudio: `${A}/ae01cbacbd9cd937_IMG_8250.webp`,
    bgProCard: `${A}/593fa510227ddb89_IMG_9250.webp`,
    bgRoom: `${A}/4c7105ecd10b8142_IMG_8551.webp`,
  },
};

export const CALENDLY_URL = "https://calendly.com/dpostigocoach/acceso-team-rnb";
export const INSTAGRAM_URL = "https://instagram.com/dpostigo91";
export const CONTACT_EMAIL = "info@rnbcoaching.com";
export const WHATSAPP_URL = `https://wa.me/34608129564?text=${encodeURIComponent(
  "Hola Dani, vengo de rnbcoaching.com y quiero información"
)}`;
export const GOOGLE_REVIEWS_URL =
  "https://www.google.com/search?q=dani+postigo+rese%C3%B1as#mpd=~15993555043820497648/customers/reviews";

export const REVIEWS = [
  {
    name: "Happy Gneddu",
    meta: "Local Guide · 207 reseñas",
    time: "hace 2 años",
    stars: 5,
    avatar: "/reviews/avatar-happy.jpg",
    photo: "/reviews/photo-happy.jpg",
    text: "Estoy realmente impresionado con la dedicación y profesionalismo de Dani. Desde el primer día, se tomó el tiempo para entender mis objetivos y diseñar un programa completamente personalizado para mí. No solo me ha ayudado a mejorar mi forma física, sino que también ha transformado mi mentalidad sobre el ejercicio y la nutrición. Lo que más valoro es su enfoque motivador y cercano, siempre disponible para resolver dudas y ofrecer el apoyo que necesito. Cada sesión con él es desafiante pero también gratificante y logra que superes tus límites. Si estás buscando un entrenador que realmente se preocupa por tu progreso y bienestar, ¡lo recomiendo sin dudas!",
  },
  {
    name: "giovanni fabbrocino",
    meta: "3 reseñas",
    time: "hace 1 año",
    stars: 5,
    avatar: "/reviews/avatar-giovanni.jpg",
    photo: null,
    text: "entrenar con dani es una experiencia completa: en este camino he mejorado mi forma física y sobre todo mi mentalidad dentro y fuera del gimnasio; Dani es una presencia constante y aprecio mucho su disponibilidad: es como tener un experto “cómplice” y amigo que te ayuda con soluciones basadas en su experiencia; no podría haber pedido algo mejor: en presencia o a distancia siempre siento que estoy siendo seguido al 100% por un profesional que realmente quiere conseguir resultados juntos, paso a paso pero con constancia en el tiempo; También lo recomendaría a aquellos que NO creen en una «relación a distancia» con un entrenador: vivo, viajo, trabajo y entreno en diferentes ciudades y gimnasios durante todo el año, Dani me ha facilitado la adaptación y creación de rutinas de entrenamiento en cada nueva ciudad/gimnasio",
  },
  {
    name: "Marta Buendia",
    meta: "Local Guide · 11 reseñas",
    time: "hace 2 años",
    stars: 5,
    avatar: "/reviews/avatar-marta.jpg",
    photo: "/reviews/photo-marta.jpg",
    text: "Entrenar con Dani es sinónimo de intensidad y calidad. Te escucha en todo lo que necesitas y te adapta la dieta y el entreno a lo que mejor te va a ir. Sabe explicarte las cosas como son y no vende milagros. Un profesional de 10 con el que quedarás satisfecho tengas el objetivo que tengas.",
  },
  {
    name: "sara garcia",
    meta: "Local Guide · 16 reseñas",
    time: "hace 2 años",
    stars: 5,
    avatar: "/reviews/avatar-sara.jpg",
    photo: null,
    text: "La calidad como entrenador es brutal, siempre atento y adaptando el plan a tus necesidades, incluso con lesión de rodilla como en mi caso. Mi salud física y mental siempre es su prioridad y eso marca la diferencia. Sin duda todo un acierto ponerme en sus manos!",
  },
  {
    name: "Sandra Suárez Moreno",
    meta: "5 reseñas",
    time: "hace 2 años",
    stars: 5,
    avatar: "/reviews/avatar-sandra.jpg",
    photo: null,
    text: "No tengo más palabras que de agradecimiento! Llevo toda mi vida a dietas, sin conseguir objetivos y pasando mucha ansiedad, pero Dani se ha adaptado a mí al 100% y está siendo bastante fácil! Siempre q lo necesito está ahí para animarme o para modificar lo que necesite de dieta o entrenamiento. Recomiendo 100%!!",
  },
  {
    name: "Miquel Alarcon",
    meta: "3 reseñas",
    time: "hace 2 años",
    stars: 5,
    avatar: "/reviews/avatar-miquel.jpg",
    photo: null,
    text: "No puedo decir nada más que cosas buenas del servicio que ofrece. Desde el primer día ejerciendo un seguimiento personalizado y exhaustivo, tanto a nivel físico como a nivel mental, aparte del plan (tanto de entrenamiento como nutricional) que hace a cada uno de sus acesorados. Las metas de sus clientes son sus propias metas y es por ello la gran implicación que tiene día a día con su trabajo. 100% recomendable para alguien que quiera hacer un cambio hacia una mejor versión de si mismo, tanto física como mental.",
  },
  {
    name: "Javier Alonso Gámez",
    meta: "6 reseñas",
    time: "hace 2 años",
    stars: 5,
    avatar: "/reviews/avatar-javier.jpg",
    photo: null,
    text: "Puedo decir que es el mejor entrenador/preparador sin ninguna duda. Ami me ha cambiado la vida con tan solo unos meses con su dieta y sus entrenamiento. Se adapta a todas tus necesidades tanto a nivel entrenamientos como de dieta. Pero lo mejor que tiene es la ayuda psicológica que te aporta.",
  },
  {
    name: "Diego Peralta",
    meta: "1 reseña",
    time: "hace 1 año",
    stars: 5,
    avatar: "/reviews/avatar-diego.jpg",
    photo: null,
    text: "Totalmente recomendado, excelente no solo como entrenador, si no como persona. Se involucra por completamente en tu proceso, lo que me ha permitido alcanzar un nivel que nunca en mi vida lo había tenido. Además, hace que todo el camino sea llevadero y sostenible, lo cual es importante ya que quiero mantener este estilo de vida a largo plazo.",
  },
  {
    name: "jose garcia robles",
    meta: "6 reseñas",
    time: "hace 2 años",
    stars: 5,
    avatar: "/reviews/avatar-jose.jpg",
    photo: null,
    text: "Los mejores resultados que he conseguido en mi vida, la dedicación y el apoyo que te ofrece Dani son inmejorables, aparte de hacerte las dietas, éntrenos, es capaz de hacer que los días que más mal te ves sacarte las ganas para levantar cabeza y ir a reventar esos hierros.\n\nEntrenador 10, y como persona un 100, ánimo a todo aquel que quiera empezar que le de una oportunidad.",
  },
  {
    name: "Mariona Font",
    meta: "1 reseña",
    time: "hace 2 años",
    stars: 5,
    avatar: "/reviews/avatar-mariona.jpg",
    photo: null,
    text: "Dani me ha ayudado mucho tanto física como mentalmente, se ha adaptado a mi en todo lo que le he ido diciendo, en cuanto alimentación, entrenamiento, el como persona es un 10, te intenta entender en todo y te escucha siempre que lo necesites.\nLos entrenos con el son una pasada y estoy aprendiendo cada día a meterle más intensidad a mis entrenamientos y en cuanto a la alimentación siempre me ha puesto los alimentos que me han gustado, y variedad para poder escoger, me ha puesto varias opciones y así no me canso de siempre lo mismo🙏\nUn 10 como persona y profesional!",
  },
  {
    name: "Hector Marquez",
    meta: "4 reseñas",
    time: "hace 2 años",
    stars: 5,
    avatar: "/reviews/avatar-hector.jpg",
    photo: null,
    text: "Llevaba AÑOS intentando conseguir un cambio físico (siempre he sido muy delgado y por mi metabolismo nunca cogía músculo comiera lo que comiera) y Dani ha conseguido en 6 meses lo que yo pensaba que era imposible. Te va a apretar, te va a exigir pero creeme que si sigues lo que hace las cambios van a llegar. Aparte algo que me gusta de el es su trato cercano con revisiones mensuales presenciales para ver la evolución. Un entrenador de 10.",
  },
  {
    name: "Angel Lopez",
    meta: "10 reseñas",
    time: "hace 2 años",
    stars: 5,
    avatar: "/reviews/avatar-angel.jpg",
    photo: null,
    text: "La experiencia, en los meses que llevo con él no podría ser mejor. Físicamente me encuentro mejor que nunca. Es un entrenador muy cercano y empático y lo más importante, muy profesional. Se adapta rápidamente a tus necesidades y siempre está dispuesto a realizar algún cambio en el programa con tal de aumentar la adherencia. Muy, muy recomendable.",
  },
  {
    name: "David Palomo",
    meta: "3 reseñas",
    time: "hace 2 años",
    stars: 5,
    avatar: "/reviews/avatar-david.jpg",
    photo: null,
    text: "Llevo 3 meses y estoy encantado. Se adapta a tu modo de vida y te ayuda a mejorarlo poco a poco en base a incorporar mejores habitos.\n\nRespecto al entreno muy atento a todo, resuelve todas las dudas y personaliza el entreno en base a tus necesidades. Yo he empezado de 0 sin saber coger una mancuerna y se agradece la paciencia y dedicación que ofrece!",
  },
  {
    name: "Pol Daza",
    meta: "Reseña de Google",
    time: "hace 2 años",
    stars: 5,
    avatar: "/reviews/avatar-pol.jpg",
    photo: null,
    text: "Dani es un gran profesional, muy aplicado en todos los aspectos. Siempre es un placer estar junto a él.",
  },
  {
    name: "Victor Gonzalez Torres",
    meta: "Reseña de Google",
    time: "hace 2 años",
    stars: 5,
    avatar: "/reviews/avatar-victor.jpg",
    photo: null,
    text: "Si estás estancado y buscas resultados 100 % asegurados, hazle caso a este man porque te va a enseñar a entrenar de verdad y avanzar, repito 100%, recomendado totalmente",
  },
  {
    name: "ignacio valtierra cabello",
    meta: "Reseña de Google",
    time: "hace 2 años",
    stars: 5,
    avatar: "/reviews/avatar-ignacio.jpg",
    photo: null,
    text: "Perseverancia, motivación y sobre todo resultados…a seguir trabajando juntos muchos años más 💪",
  },
  {
    name: "Alejandro Pardo",
    meta: "Reseña de Google",
    time: "hace 2 años",
    stars: 5,
    avatar: "/reviews/avatar-alejandro.jpg",
    photo: null,
    text: "Un gran profesional, se adapta perfectamente a tu estilo de vida y hace que des tu 100%",
  },
];

export const NAV_LINKS = [
  { label: "INICIO", hash: "#inicio" },
  { label: "ACERCA DE MÍ", hash: "#sobre-mi" },
  { label: "MI APP", hash: "#planes" },
  { label: "COACHING VIP", hash: "#coaching-vip" },
  { label: "PREGUNTAS FRECUENTES", hash: "#faq" },
  { label: "CONTACTO", hash: "#contacto" },
];

export const METHOD_POINTS = [
  {
    num: "01",
    title: "SIN IMPROVISAR",
    text: "Cada entreno y cada comida tienen un porqué. Se acabó entrenar a ciegas.",
  },
  {
    num: "02",
    title: "SIN VIVIR PARA EL GIMNASIO",
    text: "Pensado para gente con trabajo, estrés y poco tiempo. Hacer bien lo importante es suficiente.",
  },
  {
    num: "03",
    title: "SIN ATAJOS",
    text: "Progreso 100% natural. Lo que construyes así, se queda.",
  },
  {
    num: "04",
    title: "SEGUIMIENTO REAL",
    text: "Revisión semanal y corrección de tu técnica. No estás solo en esto.",
  },
];

export const APP_INCLUDES = [
  "Método de entrenamiento personalizado a tu objetivo",
  "Método de nutrición a medida",
  "Vídeos demostrativos de cada ejercicio",
  "Opciones para casa y gimnasio",
  "Registro de entrenamientos y progreso",
  "Lista de la compra",
  "Opciones para comer en casa o fuera",
  "Resolución de dudas dentro de la app",
  "Comunidad privada en WhatsApp",
  "App móvil exclusiva",
];

export const PLANS = [
  { name: "MÉTODO MENSUAL", price: "45,99 €", note: "*Pago mensual recurrente" },
  { name: "MÉTODO TRIMESTRAL", price: "119,99 €", note: "*Pago cada tres meses (40 €/mes)" },
  { name: "MÉTODO ANUAL", price: "399,99 €", note: "*Pago cada 12 meses (33,33 €/mes)", highlight: true },
];

export const APP_BLOCKS = [
  {
    title: "MÉTODO DE ENTRENAMIENTO PERSONALIZADO",
    text: "Un programa diseñado para ti que evoluciona contigo. Cada ejercicio tiene su vídeo para que sepas exactamente cómo hacerlo y saques el máximo de cada sesión.",
    points: [
      { head: "CAMBIA TUS EJERCICIOS", body: "¿Molestias o una lesión? Sustituye cualquier ejercicio cuando lo necesites." },
      { head: "REGISTRO DE ENTRENAMIENTO", body: "Controla tu progreso y supera tus marcas semana a semana." },
      { head: "EN CASA O EN EL GYM", body: "Entrena donde te sea más cómodo. Lo importante es avanzar." },
    ],
  },
  {
    title: "MÉTODO DE NUTRICIÓN PERSONALIZADO",
    text: "Hechos a tu medida, según tu objetivo y tu rutina. Se ajustan según tu progreso, con opciones para cualquier tipo de alimentación.",
    points: [
      { head: "COMIDAS EN CASA O FUERA", body: "Sal a comer sin dejar de lado tus objetivos." },
      { head: "LISTA DE LA COMPRA", body: "Sigue la lista y listo." },
      { head: "CAMBIO DE COMIDA", body: "¿Una comida no te convence? Se ajusta." },
    ],
    labels: ["General", "Vegetariana", "Vegana", "Sin lactosa", "Sin gluten", "Y mucho más"],
  },
  {
    title: "EXTRAS QUE MARCAN LA DIFERENCIA",
    text: "Las pequeñas cosas, bien hechas cada día, son las que construyen un gran cambio.",
    points: [
      { head: "REGISTRO DE HÁBITOS", body: "Cumple tus objetivos diarios." },
      { head: "REGISTRO DE PROGRESO", body: "Lleva el control de tus medidas y fotos." },
      { head: "COMUNIDAD PRIVADA EN WHATSAPP", body: "Comparte, pregunta y motívate con el Team RNB." },
      { head: "DUDAS RESUELTAS", body: "Respuesta a tus preguntas dentro de la app." },
    ],
  },
];

export const FAQ_ITEMS = [
  {
    q: "¿Necesito experiencia previa entrenando?",
    a: "No. El método se adapta a tu nivel, tanto si empiezas de cero como si llevas años entrenando. Diseño tu plan según tu punto de partida y lo vamos ajustando semana a semana: cada entreno y cada comida tienen un porqué, sin improvisar.",
  },
  {
    q: "¿Qué diferencia hay entre la App RNB y el Coaching VIP?",
    a: "Los dos llevan mi implicación directa: la diferencia no es con o sin Dani, es el nivel de atención. En la App RNB (próximamente) diseño y reviso yo tu método de entrenamiento y nutrición, y te acompaño a través de la app con vídeos, registros, comunidad y tus dudas resueltas. El Coaching VIP es ese mismo trabajo al máximo nivel: atención 1 a 1 directa, seguimiento semanal individualizado y acceso personal a mí hasta conseguir tu objetivo.",
  },
  {
    q: "¿Cuándo estará disponible la App RNB?",
    a: "Estamos trabajando en ella. El método y los precios ya están definidos y se activarán muy pronto. Mientras tanto, el Coaching VIP está activo: reserva tu llamada y empieza ya.",
  },
  {
    q: "¿Cómo funciona la llamada de acceso al Coaching VIP?",
    a: "Reserva tu hueco en el Calendly 'ACCESO TEAM RNB'. En la llamada vemos tu punto de partida, tu objetivo y si el coaching encaja contigo. Sin compromiso.",
  },
  {
    q: "¿El método es realmente 100% natural?",
    a: "Sí. Soy culturista profesional natural y co-fundador de OCB Spain, así que todo lo que te enseño lo aplico primero en mí. Aquí el progreso es real: sin atajos ni sustancias. Lo que construyes así, se queda.",
  },
  {
    q: "¿Puedo seguir el plan entrenando en casa?",
    a: "Sí. Los planes incluyen opciones para casa y gimnasio, y puedes sustituir ejercicios cuando lo necesites. Lo importante es avanzar, donde sea.",
  },
  {
    q: "¿La nutrición se adapta a mi tipo de alimentación?",
    a: "Totalmente. Hay opciones generales, vegetarianas, veganas, sin lactosa y sin gluten, con alternativas para comer en casa o fuera y lista de la compra incluida.",
  },
  {
    q: "¿Cómo contacto con el equipo?",
    a: "Puedes escribirnos desde la página de contacto, a info@rnbcoaching.com o por Instagram (@dpostigo91). Te respondemos lo antes posible.",
  },
];

export const LEGAL_PAGES = {
  "aviso-legal": {
    title: "AVISO LEGAL",
    sections: [
      { h: "Titular del sitio", p: "Real Natural Bodybuilding LLC (en adelante, RNB). Contacto: info@rnbcoaching.com. Sitio web: rnbcoaching.com." },
      { h: "Objeto", p: "Este sitio web ofrece información sobre los servicios de entrenamiento y nutrición online de Dani Postigo: la App RNB y el Coaching VIP. El acceso y uso del sitio implica la aceptación de este aviso legal." },
      { h: "Propiedad intelectual", p: "Todos los contenidos del sitio (textos, fotografías, logotipos, diseño) son titularidad de RNB o se usan con autorización. Queda prohibida su reproducción sin permiso expreso." },
      { h: "Responsabilidad", p: "Los contenidos de esta web tienen carácter informativo y no sustituyen el consejo médico. Antes de iniciar cualquier programa de ejercicio o nutrición, consulta con un profesional sanitario." },
    ],
  },
  "privacidad": {
    title: "POLÍTICA DE PRIVACIDAD",
    sections: [
      { h: "Responsable del tratamiento", p: "Real Natural Bodybuilding LLC. Contacto: info@rnbcoaching.com." },
      { h: "Datos que recogemos", p: "A través del formulario de contacto recogemos tu nombre, email y mensaje, con la única finalidad de responder a tu solicitud. No cedemos tus datos a terceros." },
      { h: "Base jurídica", p: "El tratamiento se basa en tu consentimiento, otorgado al enviar el formulario o contactar con nosotros." },
      { h: "Tus derechos", p: "Puedes ejercer tus derechos de acceso, rectificación, supresión, oposición, limitación y portabilidad escribiendo a info@rnbcoaching.com." },
      { h: "Conservación", p: "Conservamos los datos el tiempo necesario para atender tu solicitud y las obligaciones legales aplicables." },
    ],
  },
  "cookies": {
    title: "POLÍTICA DE COOKIES",
    sections: [
      { h: "Qué son las cookies", p: "Las cookies son pequeños archivos que se almacenan en tu dispositivo al visitar un sitio web." },
      { h: "Cookies que usamos", p: "Este sitio utiliza únicamente cookies técnicas necesarias para su funcionamiento y, en su caso, cookies analíticas para entender cómo se usa la web y mejorarla." },
      { h: "Cómo gestionarlas", p: "Puedes configurar tu navegador para rechazar o eliminar las cookies. Ten en cuenta que algunas funciones del sitio podrían verse afectadas." },
    ],
  },
  "terminos-y-condiciones": {
    title: "TÉRMINOS Y CONDICIONES",
    sections: [
      { h: "Servicios", p: "RNB ofrece servicios de coaching de entrenamiento y nutrición online. El Coaching VIP se contrata tras una llamada de valoración. La App RNB se encuentra actualmente en fase de lanzamiento: los planes y precios mostrados son informativos hasta su activación." },
      { h: "Contratación y pagos", p: "Las condiciones concretas del Coaching VIP (duración, precio y forma de pago) se acuerdan de forma individualizada durante la llamada de acceso. Cuando la App RNB esté disponible, los pagos se realizarán a través de la pasarela habilitada al efecto." },
      { h: "Cancelaciones", p: "Las llamadas reservadas a través de Calendly pueden cancelarse o reprogramarse desde el propio enlace de confirmación." },
      { h: "Salud", p: "Los programas de RNB no sustituyen el consejo médico. Consulta con un profesional sanitario antes de empezar cualquier programa de ejercicio o cambio nutricional." },
    ],
  },
};
